export default __webpack_public_path__ + "static/media/0293_10_Jalousiesteuerung_170608_extra_teppich.542fa2be.jpg";